import React, { ReactElement } from "react";
import { observer } from "mobx-react";
import { useStore } from "store";
import styles from "./RegionLabel.module.scss";

type Props = {
  icon: ReactElement;
};

const RegionLabel: React.FC<Props> = ({ icon }: Props) => {
  const { location } = useStore();
  const deliveryValue = location.region?.name || "Указать";
  return (
    <div className={styles.label} onClick={() => location.requestRegion()}>
      {icon}
      <span>{deliveryValue}</span>
    </div>
  );
};

export default observer(RegionLabel);
